import base64ToBlob from "../../../../utils/Base64ToBlob";

// Uploading the photos of the vehicle (tampak depan / kiri / kanan / belakang).
const useEditorImageApi = ({
  uiContext,
  requestPost,
  headerData,
  setPengecekanData,
  pengecekanDetilData,
  setPengecekanDetilData,
  saveDetilMany,
}) => {
  // The markings of a photo card keep the url of the photo they were made on: when the photo is replaced they
  // are moved to the new one. Saved markings are saved again, staged ones (no id yet) only change locally.
  const moveMarkingsToNewGambar = ({ field, gambar }) => {
    const markings = pengecekanDetilData.filter(
      (detil) => detil.label_grup === field
    );
    if (markings.length === 0) return;

    setPengecekanDetilData((list) =>
      list.map((detil) =>
        detil.label_grup === field && !detil.id ? { ...detil, gambar } : detil
      )
    );

    const saved = markings.filter((detil) => detil.id);
    if (saved.length > 0) {
      saveDetilMany({
        pengecekanDetilData: saved.map((detil) => ({ ...detil, gambar })),
      });
    }
  };

  const savePengecekanBase64Image = async ({ field, base64Image }) => {
    // an audit of only a trailer has no kendaraan, but still has photos (gambar_box_*)
    if (!headerData?.id) return;

    const blob = base64ToBlob(base64Image);
    const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
    const formData = new FormData();
    formData.append(field, file);
    formData.append("id", headerData.id);

    requestPost({
      fullUrl: `/api/audit/auditkendaraan/update`,
      formBody: formData,
      isForm: true,
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data }) => {
        uiContext.showSuccessMsg("Success", `Image updated`);
        setPengecekanData((current) => ({
          ...current,
          [field]: `${data[field]}?serial=${Math.random()}`,
        }));
        moveMarkingsToNewGambar({ field, gambar: data[field] });
      },
    });
  };

  return {
    savePengecekanBase64Image,
  };
};

export default useEditorImageApi;
